import { render, staticRenderFns } from "./Breadcrumbs.template.vue?vue&type=template&id=20704260&scoped=true&"
var script = {}
import style0 from "./Breadcrumbs.template.vue?vue&type=style&index=0&id=20704260&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20704260",
  null
  
)

export default component.exports